import React from "react";
import "../index";
const Footer = () => {
    return (
        <div className="border-t border-gray-800 mt-12">
            <footer className="text-gray-400 text-center py-8 text-sm">
                <div className="container mx-auto">
                    <p className="mb-4 text-xs uppercase tracking-widest">Stay in touch</p>
                    <div className="flex justify-center space-x-6">
                        <a 
                            href="https://www.linkedin.com/in/kartikpapney/" 
                            target="_blank" 
                            rel="noreferrer" 
                            className="hover:text-white transition duration-300"
                        >
                            LinkedIn
                        </a>
                        <a 
                            href="https://github.com/kartikpapney" 
                            target="_blank" 
                            rel="noreferrer" 
                            className="hover:text-white transition duration-300"
                        >
                            GitHub
                        </a>
                        <a 
                            href="mailto:pdt.kartik@gmail.com" 
                            className="hover:text-white transition duration-300"
                        >
                            Email
                        </a>
                    </div>
                    <p className="mt-6 text-xs text-gray-600">&copy; {new Date().getFullYear()} Kartik Papney. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
